import { useSyncExternalStore } from "react";
import { MIN_LAYER_ZOOM } from "../../lib/hexCoverage";

// The map's current zoom, reported by the map (LiveMap) while a coverage layer is shown, so the legends can say when a layer
// is not drawn because the map is zoomed out (below zoom 9). Null until the map has reported. One store for every coverage
// layer: they share the map and the zoom gate.
let mapZoom: number | null = null;
const zoomListeners = new Set<() => void>();

export function setMapZoom(zoom: number | null) {
  if (zoom === mapZoom) return;
  mapZoom = zoom;
  zoomListeners.forEach((l) => l());
}

function subscribeZoom(l: () => void) {
  zoomListeners.add(l);
  return () => {
    zoomListeners.delete(l);
  };
}

function zoomSnapshot() {
  return mapZoom;
}

/** True while the map is zoomed out past the point where coverage layers are drawn. */
export function useZoomedOut(): boolean {
  const zoom = useSyncExternalStore(subscribeZoom, zoomSnapshot, zoomSnapshot);
  return zoom !== null && zoom < MIN_LAYER_ZOOM;
}
